import * as supplierSkin from 'js/gs/supplier-skin'
import {openExternalLinksInNewTab, postLoadImages} from 'javascripts/sitebase/es/html-manipulation'

$(window).on("load", function() {
	// on phone, change the pdf viewer link into a direct pdf link.
	if ($("html").hasClass("phone") && ($("html").hasClass("ds") || $("html").hasClass("sd"))) {
		const productLinks = $("#secondary-content .product-links").detach();
		productLinks.appendTo("#product-detail-container .product-description-container");
	}
});

$(function() {
	postLoadImages()
	openExternalLinksInNewTab()
	handleViewMoreButtonDisplay()

	$('.product-image-container').on("click",function(){
		if ( $("html").hasClass("desktop") ) {
			$(this).find('.product-image-larger').toggle();
		}
	});

	$(".expandable-text-trigger-link").on("click", function() {
		const targetSelector = "." + $(this).attr("data-targetContainerClass");
		const targetIsCollapsed = $(targetSelector).hasClass("collapsed");

		if (targetIsCollapsed) {
			$(targetSelector).removeClass("collapsed");
			$(this).text("View Less");
		} else {
			$(targetSelector).addClass("collapsed");
			$(this).text("View More");
		}
	});

	if ($("#rfq-modal").length) {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('viewRfqForm')) {
			showRfqForm(0);
		}

		$(".rfq-button.product-rfq, .rfq-button.pa-rfq").click(function(e) {
			let rfqDataIndex = $(e.currentTarget).attr('rfqDataIndex') || currentRfqDataIndex;
			e.preventDefault();

			showRfqForm(rfqDataIndex);
		});
	}

	$(".close, .close-button, #sitewide-overlay").click(function(e) {
		e.preventDefault();
		$("#rfq-modal, #sitewide-overlay").fadeOut();
	});

	$("#rfq-modal-form .input-field textarea[name='rfq_partDescription']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event121', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Description');
	});

	$("#rfq-modal-form .input-field input[name='rfq_quantity']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event122', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Quantity');
	});

	$("#rfq-modal-form .input-field input[name='rfq_unit']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event123', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Unit');
	});

	$("#rfq-modal-form .input-field input[name='rfq_neededby']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event124', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Needed By');
	});

	$("#rfq-modal-form .input-field input[name='rfq_isBudgetSpecified']").click(function(e) {
		if($(this).prop('checked')) {
			trackOmniClick(window.s_account, 'event125', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Budget Allocated Selected');
		} else {
			trackOmniClick(window.s_account, 'event125', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Budget Allocated Deselected');
		}
	});

	$("#rfq-modal-form .input-field input[name='email']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event126', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Email');
	});

	$("#rfq-modal-form .input-field input[name='companyname']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event127', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Company');
	});

	$("#rfq-modal-form .input-field input[name='phone']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event128', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Phone');
	});

	$("#rfq-modal-form .input-field textarea[name='comment']").focusout(function(e) {
		trackOmniClick(window.s_account, 'event129', {channel: s.channel, eVar3: s.eVar3, eVar4: s.eVar4, prop3: s.eVar4, eVar13: s.eVar13}, 'RFQ form input: Comment');
	});


	$("#rfq-modal-form .input-field .input").focus(function(e) {
		e.preventDefault();
		$(this).parent(".input-field").addClass("active");
	});

	$("#rfq-modal-form .input-field .input").blur(function(e) {
		e.preventDefault();
		const field = $(this);
		setTimeout(function() {
			if (field.val().length) {
				field.parent(".input-field").addClass("filled");
			}
			field.parent(".input-field").removeClass("active");
		}, 250);
	});

	$("#rfq-modal-form").submit(function(e) {
		e.preventDefault();

		if ($("html").hasClass("phone") && $("html").hasClass("ds")) {
			$("html, body").animate({scrollTop: 0}, "slow");
		}

		if ($(this).valid()) {
			$(".form-wrapper").fadeOut(300, function() {
				$("html, body").animate({ scrollTop: 0 }, "slow");
				$("#form-loader").fadeIn(300);
			});

			$.ajax({
				url: "/ajax/rfq",
				type: "POST",
				data: $(this).serialize(),
				timeout: 20000,
				dataType: "json",
			}).done(function(result) {
				if (result.SUCCESS) {
					arrayOfDataForRfqForms[currentRfqDataIndex].success = true;

					trackOmniClick(window.s_account, 'event68', {channel: s.channel, eVar1: s.channel, eVar5: s.pageName, eVar95: result.PRODUCTNUMBER}, 'RFQ Submitted');
					$("#success-msg .message").html(result.MESSAGE);
					setTimeout(function() {
						$("#form-loader").fadeOut(300, function() {
							$("#success-msg").fadeIn(300);
						});
					}, 650);

					$("html, body").animate({ scrollTop: 0 }, "slow");

					assertRfqSubmittedToken();
				} else {
					if (result.VALIDATIONERROR) {
						$(".validation-error-container").html(result.VALIDATIONERRORMESSAGE).show();
						setTimeout(function() {
							$("#form-loader").fadeOut(300, function() {
								$(".form-wrapper").fadeIn(300);
							});
						}, 650);
					} else {
						$("#error-msg .message").html(result.ERROR);
						setTimeout(function() {
							$("#form-loader").fadeOut(300, function() {
								$("#error-msg").fadeIn(300);
							});
						}, 650);
					}

					$("html, body").animate({ scrollTop: 0 }, "slow");
				}
			}).fail(function() {
				$("#error-msg .message").html("An Error occurred. Your email was not sent. Please try again later.");
				setTimeout(function() {
					$("#form-loader").fadeOut(300, function() {
						$("#error-msg").fadeIn(300);
					});
				}, 650);
			});
		}

		return false;
	});

	$("#service-rfq-modal-form").validate({
		ignore: ":hidden:not(.do-not-ignore)",
		rules: {
			"hiddenRecaptcha": {
				required: function() {
					return grecaptcha.getResponse() === "";
				},
			},
		},
		errorLabelContainer: ".validation-error-container",
		wrapper: "li",
		errorClass: "validation-error",
		messages: {
			hiddenRecaptcha: "Please complete the Proof of Humanity",
		},
	});

	$("#rfq-modal-form").validate({
		ignore: ":hidden:not(.do-not-ignore)",
		rules: {
			"rfq_partDescription": "required",
			"rfq_quantity": {
				required: true,
				number: true,
			},
			"rfq_neededby": {
				required: true,
				date: true,
			},
			"email": {
				required: true,
				email: true,
				notEqual: "demo@globalspec.com",
				pattern: /^(.)+(@)(.)+[.](.)+$/,
			},
			"companyname": "required",
			"comment": "required",
			"hiddenRecaptcha": {
				required: function() {
					return grecaptcha.getResponse() === "";
				},
			},
		},
		errorLabelContainer: ".validation-error-container",
		wrapper: "li",
		errorClass: "validation-error",
		messages: {
			rfq_partDescription: "Product Name must be specified.",
			rfq_quantity: {
				required: "A quantity must be entered.",
				number: "The quantity field must be numeric.",
			},
			rfq_neededby: {
				required: "You must select a 'needed by' date.",
				date: "The needed by date must be in a valid date format.",
			},
			companyname: "The company name is required.",
			comment: "Please enter a message to the Supplier.",
			email: {
				required: "The 'Email Address' field cannot be empty.",
				email: "The 'Email Address' must be in a valid email format.",
				notEqual: "This email address is reserved, please use another.",
				pattern: "The 'Email Address' must be in a valid email format.",
			},
			hiddenRecaptcha: "Please complete the Proof of Humanity",
		},
	});
});

// eslint-disable-next-line no-unused-vars
function recaptchaJsValidateCallback() {
	$("#hiddenRecaptcha").valid();
}

function handleViewMoreButtonDisplay() {
	const imageHeight = $(".product-description-container .part-image-wrapper").outerHeight();
	const descriptionHeight = $(".product-description-container .product-description").outerHeight();

	if (descriptionHeight < imageHeight) {
		$(".product-description-container .product-description .text-fade, .product-overview .expandable-text-trigger-container").remove()
	}
}

function showRfqForm(rfqDataIndex) {
	let rfqData = arrayOfDataForRfqForms[rfqDataIndex];
	// note: attribute names in rfqData are all lowercase

	if (!rfqData.canemailthisvendor) {
		alert("You cannot email this supplier");
		return;
	}

	let rfqForm = $("#rfq-modal-form");

	// if we changed forms, reset the message windows
	let isSuccess = rfqData.success || false;
	$("#success-msg").toggle(isSuccess);
	$(".form-wrapper").toggle(!isSuccess); // show form if not yet successful
	$("#form-loader, #error-msg").hide();

	let oldRfqData = arrayOfDataForRfqForms[currentRfqDataIndex];
	currentRfqDataIndex = rfqDataIndex;


	// preserve user entered data
	let rfq_quantity = rfqForm.find("input[name=rfq_quantity]");
	let rfq_unit = rfqForm.find("input[name=rfq_unit]");
	let rfq_neededby = rfqForm.find("input[name=rfq_neededby]");
	let comment = rfqForm.find("#comment");
	let rfq_isBudgetSpecified = rfqForm.find("input[name=rfq_isBudgetSpecified]");

	oldRfqData.rfq_quantity = rfq_quantity.val();
	oldRfqData.rfq_unit = rfq_unit.val();
	oldRfqData.rfq_neededby = rfq_neededby.val();
	oldRfqData.comment = comment.val();
	oldRfqData.rfq_isBudgetSpecified = rfq_isBudgetSpecified.prop( "checked" );

	// clear errors
	rfqForm.find(".validation-error").removeClass("validation-error");
	$(".validation-error-container").empty().hide();


	// initialize form fields
	let supplierNameField = rfqForm.find("input[name='rfq_supplierName']");
	supplierNameField.val(rfqData.suppliername);
	supplierNameField.closest("div").toggleClass("filled", rfqData.suppliername !== "" ? "filled" : "");

	rfqForm.find("input[name='vid']").val(rfqData.vid);

	let img = rfqForm.find("#product-image");
	img.attr("src", rfqData.imageurl);
	img.toggle(rfqData.imageurl !== "")

	let partNameField = rfqForm.find("textarea[name='rfq_partDescription']");
	partNameField.val(rfqData.partname);
	partNameField.closest("div").toggleClass("filled", rfqData.partname !== "" ? "filled" : "");

	rfqForm.find("input[name='productNumber']").val(rfqData.productnumber);

	// restore user entered data
	rfq_quantity.val(rfqData.rfq_quantity);
	rfq_unit.val(rfqData.rfq_unit);
	rfq_neededby.val(rfqData.rfq_neededby);
	comment.val(rfqData.comment);
	rfq_isBudgetSpecified.prop( "checked", rfqData.rfq_isBudgetSpecified);

	$("#rfq-modal, #sitewide-overlay").fadeIn();
	$("html, body").animate({ scrollTop: 0 }, "slow");
}
